export const webClientId = '1071510583729-1s8ftcta7n0n8lhs744je5audhjor1v7.apps.googleusercontent.com'